import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalComponent } from "../../../global-component";
import{GenericGetData} from "../../../core/models/get-data.model";
import{GetProyectoResponse} from"../models/proyecto.model";
import { SelectOptionResponse } from '../../../shared/models/generic-entities.model';
import{SaveProyecto} from"../models/request/save-proyecto.model";

@Injectable({
  providedIn: 'root'
})
export class ProyectoService {

  private urlService = 'configuraciones/proyecto/';
  constructor(private http: HttpClient) {}

  getAll(page: number, pageSize: number, filter: string) {
    let urlFilter = page === 0 || pageSize === 0 ? "" : `?pageNumber=${page}&pageSize=${pageSize}&filter=${filter}`;
    return this.http.get<GenericGetData<GetProyectoResponse[]>>(`${GlobalComponent.API_URL}${this.urlService}${"getall"}${urlFilter}`, { reportProgress: true, observe: "events" });
  }

  getAllSelectOption(clienteId: string) {
    return this.http.get<SelectOptionResponse[]>(`${GlobalComponent.API_URL}${this.urlService}select-filter?id=${clienteId}`, { reportProgress: true, observe: "events" });
  }

  save(data: SaveProyecto) {
    return this.http.post(`${GlobalComponent.API_URL}${this.urlService}${"save"}`,data, { reportProgress: true, observe: "events" });
  }

  edit(data: SaveProyecto) {
    return this.http.post(`${GlobalComponent.API_URL}${this.urlService}${"edit"}`,data, { reportProgress: true, observe: "events" });
  }
}
